// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pk9nP","col":"styles_col__31_Nn"};